/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './extract-actions.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '@angular/common';
import * as i4 from 'ngx-bootstrap/dropdown/bs-dropdown.state';
import * as i5 from 'ngx-bootstrap/dropdown/bs-dropdown.directive';
import * as i6 from 'ngx-bootstrap/component-loader/component-loader.factory';
import * as i7 from 'ngx-bootstrap/dropdown/bs-dropdown.config';
import * as i8 from 'ngx-bootstrap/dropdown/bs-dropdown-toggle.directive';
import * as i9 from 'ngx-bootstrap/dropdown/bs-dropdown-menu.directive';
import * as i10 from '../../../../../app/shared/components/extract-actions/ref-extract-actions.component';
import * as i11 from '../../../../../app/core/services/common-api.service';
import * as i12 from 'ng2-json-editor/src/shared/services/json-store.service';
import * as i13 from 'ngx-toastr';
const styles_RefExtractActionsComponent:any[] = [i0.styles];
export const RenderType_RefExtractActionsComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_RefExtractActionsComponent,data:{}});
function View_RefExtractActionsComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'a',[['class',
      'pull-right'],['target','_blank']],[[8,'href',4]],(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['How to use']))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.helpLink;
        _ck(_v,0,0,currVal_0);
      });
}
function View_RefExtractActionsComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),36,'ul',[['class',
      'dropdown-menu'],['role','menu']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(2,0,(null as any),(null as any),8,'li',[['class','menu-item'],
          ['role','menuitem']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),
          i1.ɵeld(4,0,(null as any),(null as any),5,'textarea',[['class','form-control'],
              ['placeholder','Text or URL (with http prefix)'],['type','text']],[[2,
              'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'ngModelChange'],[(null as any),'click'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend']],
              (_v,en,$event) => {
                var ad:boolean = true;
                var _co:any = _v.component;
                if (('input' === en)) {
                  const pd_0:any = ((<any>i1.ɵnov(_v,5)._handleInput($event.target.value)) !== false);
                  ad = (pd_0 && ad);
                }
                if (('blur' === en)) {
                  const pd_1:any = ((<any>i1.ɵnov(_v,5).onTouched()) !== false);
                  ad = (pd_1 && ad);
                }
                if (('compositionstart' === en)) {
                  const pd_2:any = ((<any>i1.ɵnov(_v,5)._compositionStart()) !== false);
                  ad = (pd_2 && ad);
                }
                if (('compositionend' === en)) {
                  const pd_3:any = ((<any>i1.ɵnov(_v,5)._compositionEnd($event.target.value)) !== false);
                  ad = (pd_3 && ad);
                }
                if (('ngModelChange' === en)) {
                  const pd_4:any = ((<any>(_co.source = $event)) !== false);
                  ad = (pd_4 && ad);
                }
                if (('click' === en)) {
                  const pd_5:any = ((<any>$event.stopPropagation()) !== false);
                  ad = (pd_5 && ad);
                }
                return ad;
              },(null as any),(null as any))),i1.ɵdid(5,16384,(null as any),0,i2.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.DefaultValueAccessor]),i1.ɵdid(7,671744,(null as any),0,i2.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i2.NgControl,(null as any),[i2.NgModel]),i1.ɵdid(9,16384,(null as any),0,
          i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(12,0,(null as any),(null as any),4,'li',[['class','menu-item'],
          ['role','menuitem']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),
          i1.ɵeld(14,0,(null as any),(null as any),1,'button',[['class','btn btn-default']],
              (null as any),[[(null as any),'click']],(_v,en,$event) => {
                var ad:boolean = true;
                var _co:any = _v.component;
                if (('click' === en)) {
                  const pd_0:any = ((<any>_co.onExtractClick()) !== false);
                  ad = (pd_0 && ad);
                }
                return ad;
              },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['Extract'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵeld(18,0,(null as any),(null as any),17,'li',[['class',
          'menu-item'],['role','menuitem']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵeld(20,0,(null as any),(null as any),14,'div',[['class','checkbox']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>$event.stopPropagation()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i1.ɵeld(22,0,(null as any),(null as any),8,'label',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n          '])),(_l()(),i1.ɵeld(24,0,(null as any),(null as any),
          5,'input',[['checked',''],['type','checkbox']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'change'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('change' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,25).onChange($event.target.checked)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,25).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.replaceExisting = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(25,16384,(null as any),0,i2.CheckboxControlValueAccessor,
          [i1.Renderer2,i1.ElementRef],(null as any),(null as any)),i1.ɵprd(1024,(null as any),
          i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i2.CheckboxControlValueAccessor]),i1.ɵdid(27,671744,(null as any),0,i2.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i2.NgControl,(null as any),[i2.NgModel]),i1.ɵdid(29,16384,(null as any),
          0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),(_l()(),
          i1.ɵted(-1,(null as any),[' Replace existing\n        '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_RefExtractActionsComponent_2)),i1.ɵdid(33,16384,(null as any),
          0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n  ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_7:any = _co.source;
    _ck(_v,7,0,currVal_7);
    const currVal_15:any = _co.replaceExisting;
    _ck(_v,27,0,currVal_15);
    const currVal_16:any = _co.helpLink;
    _ck(_v,33,0,currVal_16);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,9).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,9).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,9).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,9).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,9).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,9).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,9).ngClassPending;
    _ck(_v,4,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = i1.ɵnov(_v,29).ngClassUntouched;
    const currVal_9:any = i1.ɵnov(_v,29).ngClassTouched;
    const currVal_10:any = i1.ɵnov(_v,29).ngClassPristine;
    const currVal_11:any = i1.ɵnov(_v,29).ngClassDirty;
    const currVal_12:any = i1.ɵnov(_v,29).ngClassValid;
    const currVal_13:any = i1.ɵnov(_v,29).ngClassInvalid;
    const currVal_14:any = i1.ɵnov(_v,29).ngClassPending;
    _ck(_v,24,0,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14);
  });
}
export function View_RefExtractActionsComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[(_l()(),i1.ɵeld(0,16777216,(null as any),(null as any),14,'div',
      [['dropdown','']],[[2,'dropup',(null as any)],[2,'open',(null as any)],[2,'show',
          (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵprd(512,(null as any),i4.BsDropdownState,i4.BsDropdownState,([] as any[])),
      i1.ɵdid(2,212992,(null as any),0,i5.BsDropdownDirective,[i1.ElementRef,i1.Renderer2,
          i1.ViewContainerRef,i6.ComponentLoaderFactory,i7.BsDropdownConfig,i4.BsDropdownState],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵeld(4,0,(null as any),(null as any),6,'button',[['class','btn btn-default'],
          ['dropdownToggle','']],[[1,'aria-haspopup',0],[1,'disabled',0],[1,'aria-expanded',
          0]],[[(null as any),'click'],['document','click'],[(null as any),'keyup.esc']],
          (_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,5).onClick($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('document:click' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,5).onDocumentClick($event)) !== false);
              ad = (pd_1 && ad);
            }
            if (('keyup.esc' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,5).onEsc()) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(5,147456,(null as any),0,i8.BsDropdownToggleDirective,
          [i4.BsDropdownState,i1.ElementRef],(null as any),(null as any)),(_l()(),
          i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(7,0,(null as any),
          (null as any),0,'i',[['class','fa fa-list-alt']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵeld(9,0,(null as any),(null as any),0,'i',[['class',
          'fa fa-caret-down']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_RefExtractActionsComponent_1)),i1.ɵdid(13,16384,(null as any),
          0,i9.BsDropdownMenuDirective,[i4.BsDropdownState,i1.ViewContainerRef,i1.TemplateRef],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        _ck(_v,2,0);
      },(_ck,_v) => {
        const currVal_0:any = i1.ɵnov(_v,2).dropup;
        const currVal_1:any = i1.ɵnov(_v,2).isOpen;
        const currVal_2:any = (i1.ɵnov(_v,2).isOpen && i1.ɵnov(_v,2).isBs4);
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
        const currVal_3:any = true;
        const currVal_4:any = i1.ɵnov(_v,5).isDisabled;
        const currVal_5:any = i1.ɵnov(_v,5).isOpen;
        _ck(_v,4,0,currVal_3,currVal_4,currVal_5);
      });
}
export function View_RefExtractActionsComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-ref-extract-actions',
      ([] as any[]),(null as any),(null as any),(null as any),View_RefExtractActionsComponent_0,
      RenderType_RefExtractActionsComponent)),i1.ɵdid(1,49152,(null as any),0,i10.RefExtractActionsComponent,
      [i11.CommonApiService,i12.JsonStoreService,i13.ToastrService],(null as any),
      (null as any))],(null as any),(null as any));
}
export const RefExtractActionsComponentNgFactory:i1.ComponentFactory<i10.RefExtractActionsComponent> = i1.ɵccf('re-ref-extract-actions',
    i10.RefExtractActionsComponent,View_RefExtractActionsComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/shared/components/extract-actions/ref-extract-actions.component.ngfactory.ts